
<mh-core-lib-loader-wrapper class="tw-w-full tw-h-full" [type]="'spinner'" [loading]="isLoading" >
    <div class="tw-flex tw-justify-center tw-min-h-screen tw-p-8 tw-font-['Rubik']">
    <div class="tw-flex tw-flex-col tw-items-center tw-text-center tw-w-full">
        <!-- Foto de perfil -->
        <div class="tw-mb-6">
            <mh-profile-photo size="200" [image]="userProfileImage" [showIcon]="false"
                customClass="!tw-p-0 !tw-m-0 tw-pointer-events-none">
            </mh-profile-photo>
        </div>
    
        <!-- Nombre del usuario -->
        <h2 class="tw-font-['Rubik'] tw-text-3xl tw-font-medium tw-text-gray-800 tw-mb-2 tw-leading-tight">{{ userName }}
        </h2>
    
        <!-- Cargo del usuario -->
        <p class="tw-font-['Rubik'] tw-text-base tw-font-normal tw-text-gray-600 tw-mb-8 tw-leading-relaxed">{{ userPosition
            }}</p>

        <!-- Descripcion del usuario -->
        <p class="tw-font-['Rubik'] tw-text-base tw-font-normal tw-text-gray-600 tw-mb-8 tw-leading-relaxed tw-whitespace-pre-line">
            {{ 'support.menu-header.contact_executive.description_part1' | translate }}
            <a routerLink="/soporte" class="tw-text-blue-600 hover:tw-text-blue-800 tw-underline">
                {{ 'support.menu-header.contact_executive.description_link_text' | translate }}
            </a>
            {{ 'support.menu-header.contact_executive.description_part2' | translate }}
        </p>
    
        <!-- Botones de acción -->
        <div class="tw-flex tw-gap-4 tw-justify-center tw-flex-wrap tw-w-full md:tw-flex-row tw-flex-col tw-items-center">
    
            <mh-core-lib-button [text]="'commons.email' | translate" [isSecondary]="true" width="120" *ngIf="userEmail"
                customClass="tw-font-['Rubik'] tw-mb-3 md:tw-mb-0" (clicked)="onEmailClick()">
            </mh-core-lib-button>
    
            <mh-core-lib-button [text]="'commons.whatsapp' | translate" [isSecondary]="true" width="120" *ngIf="mobile" class="tw-hidden"
                customClass="tw-font-['Rubik'] tw-mb-3 md:tw-mb-0" (clicked)="onWhatsAppClick()">
            </mh-core-lib-button>
    
            <mh-core-lib-button [text]="'commons.schedule_meeting' | translate" [isSecondary]="true" width="'tw-w-fit'" *ngIf="calendar"
                customClass="tw-font-['Rubik'] tw-mb-3 md:tw-mb-0" (clicked)="onCallClick()">
            </mh-core-lib-button>
        </div>
    </div>
    </div>
</mh-core-lib-loader-wrapper>